import { render, staticRenderFns } from "./DemForTrend.vue?vue&type=template&id=57b91d66&"
import script from "./DemForTrend.vue?vue&type=script&lang=js&"
export * from "./DemForTrend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports